import { getTooltipImageSrc } from "@src/config/baseUrls";
import {
  TooltipDescription,
  TooltipDescriptionLine,
  TooltipImage,
  TooltipPosition,
} from "@src/modules/shared/components/Tooltip/Tooltip.components";
import { FunctionComponent } from "react";
import { createPortal } from "react-dom";

interface Props {
  descriptions: string[];
  isVisible: boolean;
  position: TooltipPosition;
  rect?: DOMRect;
  imageSrc?: string;
}

const TOOLTIP_PORTAL_ID = "tooltip-portal";

const TooltipPortal: FunctionComponent<Props> = ({
  descriptions,
  position,
  isVisible,
  rect,
  imageSrc,
}) => {
  if (!rect) return null;

  let safePosition = position;
  const maxTop = !!imageSrc ? 600 : 50;
  if (position === "top" && rect.top < maxTop) safePosition = "bottom";

  return createPortal(
    <TooltipDescription
      position={safePosition}
      isVisible={isVisible}
      rect={rect}
    >
      {descriptions.map((description, index) => (
        <TooltipDescriptionLine key={index}>
          {description}
        </TooltipDescriptionLine>
      ))}
      {!!imageSrc && <TooltipImage src={getTooltipImageSrc(imageSrc)} />}
    </TooltipDescription>,
    document.getElementById(TOOLTIP_PORTAL_ID)!,
  );
};

export default TooltipPortal;
